import { AsyncStatus, MetaConversation } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';
import { handleActions } from 'redux-actions';

import { emptyMetaConversation } from '../../../conversation/reducers/conversation';
import { addCallerActions } from '../actions/addCaller';

type AddCallerModalT = {
  meta: {
    addCallerAsync: AsyncStatus;
    searchUserAsync: AsyncStatus;
  };
  ui: {
    isModalShown: boolean;
  };
  users: Array<User>;
  metaConversation: MetaConversation;
};

const initialState: AddCallerModalT = {
  meta: {
    addCallerAsync: 'succeeded',
    searchUserAsync: 'succeeded',
  },
  ui: {
    isModalShown: false,
  },
  users: [],
  metaConversation: emptyMetaConversation(),
};

const {
  addCallerCallRequest,
  addCallerCallRequestSucceeded,
  addCallerCallRequestFailed,

  addCallerGetUsersByQuery,
  addCallerGetUsersByQuerySucceeded,
  addCallerGetUsersByQueryFailed,

  addCallerModalOpen,
  addCallerModalClose,
} = addCallerActions;

const addCaller = handleActions<AddCallerModalT, any>(
  {
    [addCallerModalOpen.toString()]: (state: AddCallerModalT, action) => {
      const { metaConversation } = action.payload;

      return {
        ...state,
        ui: { ...state.ui, isModalShown: true },
        metaConversation,
      };
    },

    [addCallerModalClose.toString()]: (state: AddCallerModalT) => {
      return { ...state, ui: { ...state.ui, isModalShown: false }, users: [] };
    },

    [addCallerGetUsersByQuery.toString()]: (state: AddCallerModalT) => {
      return { ...state, meta: { ...state.meta, searchUserAsync: 'loading' } };
    },

    [addCallerGetUsersByQuerySucceeded.toString()]: (
      state: AddCallerModalT,
      action,
    ) => {
      const { data } = action.payload;

      return {
        ...state,
        meta: { ...state.meta, searchUserAsync: 'succeeded' },
        users: data?.[0]?.hits || [],
      };
    },

    [addCallerGetUsersByQueryFailed.toString()]: (state: AddCallerModalT) => {
      return {
        ...state,
        meta: { ...state.meta, searchUserAsync: 'failed' },
        users: [],
      };
    },

    [addCallerCallRequest.toString()]: (state: AddCallerModalT) => {
      return {
        ...state,
        meta: { ...state.meta, addCallerAsync: 'loading' },
      };
    },

    [addCallerCallRequestSucceeded.toString()]: (state: AddCallerModalT) => {
      return {
        ...state,
        meta: { ...state.meta, addCallerAsync: 'succeeded' },
        ui: { ...state.ui, isModalShown: false },
        users: [],
        metaConversation: emptyMetaConversation(),
      };
    },

    [addCallerCallRequestFailed.toString()]: (state: AddCallerModalT) => {
      return {
        ...state,
        meta: { ...state.meta, addCallerAsync: 'failed' },
      };
    },
  },
  initialState,
);

export default addCaller;
